<script>
import {
  BANOBAGI_RIGHT_DEFINITIONS,
  BANOBAGI_RIGHT_TYPES
} from "@/utils/banobagiRights";

export default {
  name: "BanobagiStatsGrid",
  props: {
    summary: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  emits: ["open-transaction"],
  data() {
    return {
      rightLabel: BANOBAGI_RIGHT_DEFINITIONS[0].label
    };
  },
  computed: {
    displayValue() {
      if (this.isLoading) return "…";
      if (this.hasError) return "-";
      return this.numeralFormat(
        this.summary[BANOBAGI_RIGHT_TYPES.PP_KRIT_CONCERT] ?? 0
      );
    }
  }
};
</script>

<template>
  <section class="banobagi-stats" data-test="profile-stats-list">
    <button
      type="button"
      class="banobagi-stats__card"
      data-test="profile-stats-point-btn"
      :aria-label="
        $t('transaction_header') + ': ' + rightLabel + ': ' + displayValue
      "
      @click="$emit('open-transaction')"
    >
      <span class="banobagi-stats__label" data-test="profile-stats-point-label">
        {{ $t("banobagi_my_chance") || "โอกาสลุ้นของฉัน" }}
      </span>

      <span class="banobagi-stats__rights">
        <span
          class="banobagi-stats__value"
          data-test="profile-stats-point-value"
        >
          {{ displayValue }}
        </span>
        <span class="banobagi-stats__unit">{{ $t("right_unit") }}</span>
      </span>
    </button>
  </section>
</template>

<style lang="scss" scoped>
.banobagi-stats {
  position: relative;
  z-index: 1;
  margin: 0 16px;
}

.banobagi-stats__card {
  display: flex;
  width: 100%;
  min-height: 118px;
  align-items: stretch;
  gap: 16px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 24px;
  background: #1a1a1a;
  color: #ffffff;
  box-shadow: 0 12px 25px rgba(38, 72, 110, 0.28);
  cursor: pointer;
  font: inherit;
  text-align: left;
}

.banobagi-stats__card:focus-visible {
  outline: 3px solid #ffffff;
  outline-offset: 3px;
}

.banobagi-stats__label {
  min-width: 0;
  flex: 1 1 auto;
  color: #5699c9;
  font-size: var(--font-title);
  line-height: 1.3;
}

.banobagi-stats__unit {
  color: #5699c9;
  font-size: var(--font-body-sm);
}

.banobagi-stats__rights {
  display: flex;
  min-width: 88px;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.28);
}

.banobagi-stats__value {
  font-size: calc(var(--font-heading) * 1.75);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
</style>
